/**
 * @generated SignedSource<<803575e926543537e76ccc349c6ba1bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getByDocCreator_item$data = {
  readonly creators: ReadonlyArray<{
    readonly attribution: string | null;
    readonly creator: {
      readonly displayName: string | null;
      readonly name: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "getByDocCreator_item";
};
export type getByDocCreator_item$key = {
  readonly " $data"?: getByDocCreator_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"getByDocCreator_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getByDocCreator_item"
};

(node as any).hash = "ed6f5a681f42bfa8273a1866f4608189";

export default node;
